<template>
  <div>
    <div class="help-buttons">
      <h2>
        {{ subHeadlineText }}
      </h2>
      <ReactiveButton
        :is-primary-button="false"
        :button-text="$tv('goToFAQ', 'guide')"
        @click="navigateTo(localePath('/faq'))"
      />
    </div>
    <div class="pure-g cards">
      <div
        class="pure-u-1 pure-u-md-1-3"
        v-for="guide in guideList"
        :key="guide.id"
      >
        <NuxtLink
          :to="localePath('/guides' + getGuideUrl(guide))"
          class="link--with-icon"
        >
          <Card
            :title="guide.Title"
            :url="guide.Url"
            class="guide__card cardTile"
          >
            <div class="card__teaser text">
              <p class="text-light">
                {{ $tv('what', 'guide').toUpperCase() }}
              </p>
              {{ guide.Description }}
              <p class="text-light">
                {{ $tv('where', 'guide').toUpperCase() }}
              </p>
              {{ getGuidesNames(guide) }}
            </div>
          </Card>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script>
import Card from '@/components/Card.vue'

export default {
  name: 'GuideListView',
  components: {Card},
  props: {
    guideList: {
      type: Array || null,
      default: () => []
    },
    category: {
      type: Object || null,
      default: () => null
    }
  },
  computed: {
    subHeadlineText() {
      return this.category?.Title
        ? this.$tv({messageKey: 'subHeadline', messageValues: {currentGuide: this.category.Title}}, 'guidePage')
        : this.$tv('guideTitle', 'guide')
    }
  },
  methods: {
    getGuideUrl(guide) {
      return guide.guide_categories && guide.Url && guide.guide_categories.length > 0 ? '/' + guide.guide_categories[0].Url + '/' + guide.Url : ''
    },
    getGuidesNames(guide) {
      return guide.guide_categories && guide.guide_categories.length > 0 ? guide.guide_categories.map(cat => cat.Title).join(', ') : ''
    }
  },
  data() {
    return {
      lang: this.$i18n.locale
    }
  }
}
</script>

<style lang="scss">
.text-light {
  font-weight: $base-text-font-weight-bold;
  font-size: $base-text-font-size;
}

.help-buttons {
  margin-top: 1rem;

  .k-button {
    margin-top: 0;
  }
}

.guide__card {
  min-height: 17rem;
  flex-grow: 1;

  h3 {
    font-size: 1.375rem;
    margin-left: $default-margin-padding-width !important;
  }
}

</style>
